import React from "react";
import FindingResourcesCountKPI, {
  type FindingResourcesCountKPIProps,
} from "./FindingResourcesCountKPI";

type AllFindingResourcesKPIProps = Pick<
  FindingResourcesCountKPIProps,
  "selectedScope" | "filterToExecute" | "scopeToExecute" | "setIsReadyToExport"
>;

const AllFindingResourcesKPI: React.FC<AllFindingResourcesKPIProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  setIsReadyToExport = null,
}) => {
  return (
    <FindingResourcesCountKPI
      scopeToExecute={scopeToExecute}
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default AllFindingResourcesKPI;
